import AOS from 'aos'
import 'aos/dist/aos.css'

// The reveals, as AOS is meant to be run: started once the app has
// hydrated, left to watch the page itself, and refreshed on a navigation.
//
// AOS measures where each element sits and reveals it as the reader reaches
// it. The page changes height as it goes, sections coming alive as they come
// near and mocks growing as they play, so it has to measure again: its own
// MutationObserver does that, and it is left on. It was off here before,
// replaced by a hand-rolled one, and everything it did not catch stayed
// invisible on screen.
//
// Reduced motion (WCAG 2.3.3) is left to the prefers-reduced-motion block in
// assets/css/main.css, which zeroes transition duration and delay so every
// reveal lands instantly.
export default defineNuxtPlugin((nuxtApp) => {
  let started = false

  // AOS's CSS only has rules for delays in steps of 50ms, and the staggers
  // here are worked out per item (100 + i * 80 and the like), so the delay is
  // set on the element where any value works.
  function setDelays() {
    document.querySelectorAll<HTMLElement>('[data-aos-delay]').forEach((el) => {
      const delay = el.getAttribute('data-aos-delay')
      if (delay) el.style.transitionDelay = `${delay}ms`
    })
  }

  function start() {
    setDelays()
    if (!started) {
      started = true
      // Init takes its own first pass, and its observer keeps it honest from
      // then on. Once: a reveal is not taken back once it has been read.
      AOS.init({ duration: 700, easing: 'ease-out', once: true })
      return
    }
    // A new page: measure it.
    AOS.refreshHard()
  }

  nuxtApp.hook('page:loading:end', () => {
    // After the scroll for this navigation has landed, or it measures against
    // the outgoing page's offset.
    requestAnimationFrame(() => requestAnimationFrame(start))
  })
})
